// A read, typed the way a person types it: into the page's one [data-reader=box],
// then that box's own form submits (a Turbo Frame form swaps its frame).
// False when the page has no box (docs/HOTWIRE.md § bridge/).
export function typeIn(code) {
  const box = document.querySelector('[data-reader=box]');
  if (!box?.form) return false;
  box.value = code;
  box.form.requestSubmit();
  return true;
}
